import React from "react";

import { moneyFormat } from "./format";
import TwoPanels from "./TwoPanels";
import Text from "./Text";
import { IncomeStatementPanel } from "./IncomeStatement";

const MarketingFinancialImpact2 = ({ incomeStatement }) => (
  <TwoPanels
    title1="Financial Impact of Marketing Decisions"
    title2="Income Statement"
  >
    <fragment>
      <Text>
        As a result of your product and marketing decisions, your team incurred
        the following costs:
      </Text>
      <Text>
        <b>Cost of Sales</b>: Your Cost of Sales of{" "}
        {moneyFormat(-incomeStatement["Cost of Sales"])} was partly driven by
        the product feature quality. The higher the quality, the more expensive
        the materials that is needed to produce the product.
      </Text>
      <Text>
        <b>R&amp;D Costs</b>: Your R&amp;D Costs of{" "}
        {moneyFormat(incomeStatement["R&D Costs"])} was driven by the quality of
        the product features and the number of products designed by your Head of
        Product Management. Promotion Costs: Your marketing spend costs shows up
        on your Income Statement as Promotion Costs of{" "}
        {moneyFormat(-incomeStatement["Promotion Costs"])}
      </Text>
      <Text>
        <b>Selling Costs</b>: Your Selling Costs of{" "}
        {moneyFormat(-incomeStatement["Selling Costs"])} was driven by the costs
        to sell tothe customer. These costs are mainly sales commissions that
        are paid to sales representatives and/or distributors.
      </Text>
    </fragment>
    <IncomeStatementPanel sheet={incomeStatement} />
  </TwoPanels>
);

export default MarketingFinancialImpact2;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingFinancialImpact2.js